<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">MODIFICA UTENTE</div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_name" class="form-label label-fw">
                        Nome *
                    </label>
                    <input formControlName="name" name="name" type="text"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.name.errors}"
                        class="form-control form-fw " id="field_name" placeholder="Nome">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                            Nome è obbligatorio
                        </span>
                    </div>
                </div>
            </div>


            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_surname" class="form-label label-fw">
                        Cognome *
                    </label>
                    <input formControlName="surname" name="surname" type="text"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.surname.errors}"
                        class="form-control form-fw " id="field_surname" placeholder="surname">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.surname.errors && formControls.surname.errors?.required">
                            Cognome è obbligatorio
                        </span>
                    </div>
                </div>
            </div>


            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_surname" class="form-label label-fw">
                        Email *
                    </label>
                    <input formControlName="email" name="email" type="text"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.email.errors}"
                        class="form-control form-fw " id="field_email" placeholder="email">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.email.errors && formControls.email.errors?.required">
                            Email è obbligatorio
                        </span>
                        <span *ngIf="formControls.email.errors && formControls.email.errors.email">
                            Formato email errata
                        </span>
                    </div>
                </div>
            </div>


            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_role" class="form-label label-fw">
                        Ruolo *
                    </label>
                    <select formControlName="role" name="role"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.role.errors}"
                        (change)="changeRole()"
                        class="form-select select-wh" id="field_role">
                        <option value="">Nessuna</option>
                        <option value="{{role.id}}" *ngFor="let role of roles">
                            {{role.name}}
                        </option>
                    </select>
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.role.errors && formControls.role.errors?.required">
                            Ruolo è obbligatorio
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-check form-switch d-flex px-3">
                    <div class="justify-content-start w-100">
                        <label class="form-check-label toggle-text label-fw"
                            for="flexSwitchCheckChecked">Abilita</label>
                    </div>
                    <div class="justify-content-end">
                        <label class="switch">
                            <input formControlName="enabled" name="enabled" type="checkbox">
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

           

            <div [hidden]="!isVisibleSectionStore">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="field_name" class="form-label label-fw">
                            Stores associati
                        </label>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item px-0 flex" [ngClass]="{'is-deleted': store.del === true}"
                                *ngFor="let store of stores">
                                <div class="stores-list">
                                    <a href="#/store/store/{{store.id}}" rel="noopener" target="_blank">
                                        <i class="fas fa-link ora clickable blu"></i>
                                    </a>
                                    <span [hidden]="store.del">
                                        {{store.dealerDescription}} - {{store.titleSeo}}
                                    </span>
                                    <del [hidden]="!store.del">
                                        {{store.dealerDescription}} - {{store.titleSeo}}
                                    </del>
                                </div>
                                <i [hidden]="!store.del" (click)="clickButtonChangeDelStore(store.id,false)"
                                    class="fas fa-times clickable red"></i>
                                <i [hidden]="store.del" (click)="clickButtonChangeDelStore(store.id,true)"
                                    class="fas fa-times clickable red"></i>
                            </li>
                            <li class="list-group-item px-0" *ngIf="stores.length == 0">
                                Non esistono stores associati
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="field_role" class="form-label label-fw">
                            Associa store
                        </label>
                        <ng-autocomplete #storeSelect placeholder="Cerca store" [data]="storeSelect_Suggestion"
                            [searchKeyword]="storeSelect_Keyword" (selected)='selectEvent__storeSelect($event)'
                            (inputChanged)='getList_storeSelect($event)' (inputFocused)='onFocused__storeSelect($event)'
                            [itemTemplate]="itemTemplate_storeSelect" (inputCleared)="searchCleared__storeSelect()"
                            [notFoundTemplate]="notFoundTemplate_storeSelect" [debounceTime]="600"
                            [isLoading]="storeSelect_isKeywordLoadingResult" [minQueryLength]="2">
                        </ng-autocomplete>
                        <ng-template #itemTemplate_storeSelect let-item>
                            <div class="col-12">
                                <div class="mx-3">
                                    <span [innerHTML]="item.titleSeo"></span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #notFoundTemplate_storeSelect let-notFound>
                            {{errorMsg_storeSelect}}
                        </ng-template>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <fieldset class="fieldset-fw" [hidden]="storeSelect_Selected.length === 0">
                            <legend hidden></legend>
                            <app-draggable-list-chip [itemList]="storeSelect_Selected"
                                [labelKeys]="labelKeys_storeSelect" [draggable]="false"
                                (changeItemList)="onChangeItemList_storeSelect($event)">
                            </app-draggable-list-chip>
                        </fieldset>
                    </div>
                </div>
            </div>



        </div>

        <div class="row text-center">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" [hidden]="isVisibleMsg === false">
                <div class="alert alert-warning m-3" role="alert">
                    {{avvisoMSG}}
                </div>
            </div>
        </div>
    </form>



    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3"
                [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false"
                (click)="clickButtonSave()">Salva</button>
            <button type="button" class="btn btn-outline-fw text"
                (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>